<div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [plotOptions]="chartOptions.plotOptions"
      [xaxis]="chartOptions.xaxis"
    ></apx-chart>
</div>